var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoublearrowend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 69,
    viewBox: "0 0 91 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.1621 6.39477C87.3121 11.8648 90.0771 17.9998 90.0771 27.9448C90.0771 45.4448 77.7921 61.1298 59.9272 68.8848L55.4621 61.9948C72.1371 52.9748 75.3971 41.2698 76.6971 33.8898C74.0121 35.2798 70.4971 35.7648 67.0521 35.4448C58.0321 34.6098 50.9221 27.2048 50.9221 17.9998C50.9221 13.3585 52.7659 8.90728 56.0478 5.62539C59.3297 2.34351 63.7809 0.499763 68.4221 0.499763C70.9889 0.522194 73.5255 1.05494 75.8843 2.06699C78.2432 3.07903 80.3772 4.55018 82.1621 6.39477ZM32.1621 6.39477C37.3121 11.8648 40.0771 17.9998 40.0771 27.9448C40.0771 45.4448 27.7921 61.1298 9.92715 68.8848L5.46214 61.9948C22.1371 52.9748 25.3971 41.2698 26.6972 33.8898C24.0122 35.2798 20.4972 35.7648 17.0522 35.4448C8.03215 34.6098 0.92215 27.2048 0.92215 17.9998C0.92215 13.3585 2.76589 8.90728 6.04778 5.62539C9.32967 2.34351 13.7809 0.499763 18.4221 0.499763C20.9889 0.522194 23.5255 1.05494 25.8843 2.06699C28.2432 3.07903 30.3772 4.55018 32.1621 6.39477Z",
    fill: "#878787",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoublearrowend);
export default __webpack_public_path__ + "static/media/doublearrowend.32ec6c58be841dbbad27dbfa87936a32.svg";
export { ForwardRef as ReactComponent };